import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-456c7d40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_3 = { class: "team" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Christian Herzmann", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Medical doctor specialized in respiratory medicine and tuberculosis", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, [
  /*#__PURE__*/_createTextVNode("While visiting a Tuberculosis-conference, he had that great idea of an App, which accompanies TB-patients during their treatment. The idea of the TBCompanion was born. He developed the App together with Rick, wrote most of the dialogues and set up the scenery of TBCompanion. He works at the Research Center Borstel and is also the founder of "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "info",
    href: "https://www.explaintb.org"
  }, "ExplainTB!")
], -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "team" }
const _hoisted_10 = {
  key: 0,
  class: "image"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Ralf Otto-Knapp", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Medical doctor specialized in respiratory medicine, infectious disease and tuberculosis", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Ralf works together with Brit at the DZK – an organization for all aspects of TB in Germany. Ralf is passionate about making the APP user friendly and developed a lot of the dialogues together with Christian and was responsible for the finetuning of the APP.", -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "image"
}
const _hoisted_16 = { class: "team" }
const _hoisted_17 = { class: "image" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<p class=\"name\" data-v-456c7d40>Brit Häcker</p><p class=\"profession\" data-v-456c7d40>Medical doctor in the field of respiratory medicine and tuberculosis</p><br data-v-456c7d40><p class=\"name\" data-v-456c7d40>Christine Trost</p><p class=\"profession\" data-v-456c7d40>Administration, Project Management</p><p class=\"info\" data-v-456c7d40>They work together with Ralf at the DZK – an organization for all aspects of TB in Germany. Brit hates losing the fight against these mycobacteria and deals together with Christine with most of the organizational stuff for TBCompanion.</p>", 6)
const _hoisted_24 = [
  _hoisted_18
]
const _hoisted_25 = { class: "team" }
const _hoisted_26 = {
  key: 0,
  class: "image"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Vanessa Igbokwe", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Medical student", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Vanessa is a final-year medical student and works at DZK next to her studies. She has a high interest in infectious diseases and tuberculosis, and, still being a learner herself, she believes that patient education is the key to patient empowerment. Within the TB Companion study, she helps mostly with patient recruitment.", -1))
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "image"
}
const _hoisted_32 = { class: "team" }
const _hoisted_33 = { class: "image" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Estera Pușcașu", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Medical student", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Estera is part of the DZK Team and likes building a relationship based on trust with the patients. She supports the team by recruiting and counselling patients. Being a native Romanian, this project was close to her heart. Speaking German, English and Romanian proved to be an important asset to the project.", -1))
const _hoisted_37 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "team" }
const _hoisted_39 = {
  key: 0,
  class: "image"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Rick Shaikh", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Software Engineer", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Rick is the technincal lead and developer behind TBCompanion. He brings all our ideas to life and is responsible for programming and maintaining the TBCompanion-App, so your companion can now support you through your TB treatment.", -1))
const _hoisted_43 = [
  _hoisted_40,
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  class: "image"
}
const _hoisted_45 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_46 = { class: "team" }
const _hoisted_47 = { class: "image" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Christian Herzmann", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Medic specializat în medicină respiratorie și tuberculoză", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, [
  /*#__PURE__*/_createTextVNode("În timp ce vizita o conferință de tuberculoză, el a avut o idee grozavă a unei aplicații, care însoțește pacienții bolnavi de tuberculoză pe parcursul tratamentului lor. Așa s-a născut ideea de TBCompanion. El a dezvoltat aplicația împreună cu Rick, a scris majoritatea dialogurilor și a stabilit scenariul TBCompanion. Lucrează la Centrul de Cercetare Borstel și este, de asemenea, fondatorul "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "info",
    href: "https://www.explaintb.org"
  }, "ExplainTB.")
], -1))
const _hoisted_51 = [
  _hoisted_48,
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = { class: "team" }
const _hoisted_53 = {
  key: 0,
  class: "image"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Ralf Otto-Knapp", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Medic specializat în medicină respiratorie, boli infecțioase și tuberculoză", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Ralf colaborează cu Brit la DZK – o organizație care se ocupă cu toate aspectele legate de tuberculoză din Germania. Ralf este pasionat de a face aplicația ușor de utilizat și a dezvoltat o mulțime de dialoguri împreună cu Christian, fiind de asemenea responsabil pentru ajustarea aplicației.", -1))
const _hoisted_57 = [
  _hoisted_54,
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  key: 1,
  class: "image"
}
const _hoisted_59 = { class: "team" }
const _hoisted_60 = { class: "image" }
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<p class=\"name\" data-v-456c7d40>Brit Häcker</p><p class=\"profession\" data-v-456c7d40>Medic în domeniul medicinei respiratorii și al tuberculozei</p><br data-v-456c7d40><p class=\"name\" data-v-456c7d40>Christine Trost</p><p class=\"profession\" data-v-456c7d40>Administrație, management de proiect</p><p class=\"info\" data-v-456c7d40>Ele lucrează împreună cu Ralf la DZK – o organizație care se ocupă cu toate aspectele legate de tuberculoză din Germania. Brit urăște sa piardă lupta împotriva micobacteriilor și se ocupă, împreună cu Christine, de majoritatea lucrurilor organizaționale pentru TBCompanion.</p>", 6)
const _hoisted_67 = [
  _hoisted_61
]
const _hoisted_68 = { class: "team" }
const _hoisted_69 = {
  key: 0,
  class: "image"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Vanessa Igbokwe", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Studentă la medicină", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Vanessa e studentă la medicină în ultimul an și lucrează la DZK în paralel cu studiul. Are un interes ridicat în boli infecțioase și tuberculoză, și fiind o persoană care încă învață, ea crede ca educarea pacienților reprezintă cheia abilitării acestora. În cadrul studiului cu TB Companion, ea ajută mai ales cu recrutarea pacienților.", -1))
const _hoisted_73 = [
  _hoisted_70,
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = {
  key: 1,
  class: "image"
}
const _hoisted_75 = { class: "team" }
const _hoisted_76 = { class: "image" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Estera Pușcașu", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Studentă la medicină", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Face parte din echipa DZK și îi place să construiască relații bazate pe încredere cu pacienții. Susține echipa prin recrutarea și consilierea pacienților. Fiind româncă, s-a atașat rapid de acest proiect. Faptul că vorbește germană, engleză și română s-a dovedit a fi de un real folos.", -1))
const _hoisted_80 = [
  _hoisted_77,
  _hoisted_78,
  _hoisted_79
]
const _hoisted_81 = { class: "team" }
const _hoisted_82 = {
  key: 0,
  class: "image"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Rick Shaikh", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Inginer de software", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Rick este liderul tehnic și developerul din spatele TBCompanion. El aduce la viață toate ideile noastre și este responsabil pentru programarea și menținerea aplicației TBCompanion, astfel încât partenerul dvs. virtual să vă poată sprijini pe parcursul tratamentului de tuberculoză.", -1))
const _hoisted_86 = [
  _hoisted_83,
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = {
  key: 1,
  class: "image"
}
const _hoisted_88 = {
  key: 2,
  class: "placeholder"
}
const _hoisted_89 = { class: "team" }
const _hoisted_90 = { class: "image" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Christian Herzmann", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Лікар за спеціальністю респіраторна медицина та туберкульоз", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, [
  /*#__PURE__*/_createTextVNode("Під час відвідування конференції з туберкульозу у нього виникла чудова ідея створити прикладну програму, яка буде супроводжувати хворих на туберкульоз під час лікування. Так народився проект TB Companion. Разом із Ріком він розробив додаток, написав більшість діалогів і створив сценарій для TB Companion. Крістіан працює в дослідницькому центрі комуни Борстель, він є засновником проекту "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "info",
    href: "https://www.explaintb.org"
  }, "ExplainTB.")
], -1))
const _hoisted_94 = [
  _hoisted_91,
  _hoisted_92,
  _hoisted_93
]
const _hoisted_95 = { class: "team" }
const _hoisted_96 = {
  key: 0,
  class: "image"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Ralf Otto-Knapp", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Лікар за спеціальністю респіраторна медицина, інфекційні хвороби та туберкульоз", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Ральф працює разом із Брітою в DZK – організації, яка займається усіма питаннями туберкульозу в Німеччині. Ральф пристрасно прагне зробити додаток зручним для користувача, для цього він розробив багато діалогів разом із Крістіаном і відповідав за точне налаштування додатку.", -1))
const _hoisted_100 = [
  _hoisted_97,
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = {
  key: 1,
  class: "image"
}
const _hoisted_102 = { class: "team" }
const _hoisted_103 = { class: "image" }
const _hoisted_104 = /*#__PURE__*/_createStaticVNode("<p class=\"name\" data-v-456c7d40>Brit Häcker</p><p class=\"profession\" data-v-456c7d40>Лікар в галузі респіраторної медицини та фтизіатрії</p><br data-v-456c7d40><p class=\"name\" data-v-456c7d40>Christine Trost</p><p class=\"profession\" data-v-456c7d40>Адміністратор, менеджер проектів</p><p class=\"info\" data-v-456c7d40>Крістін працює разом з Ральфом в DZK – організації, яка займається усіма питаннями туберкульозу в Німеччині. Крістін не любить програвати у боротьбі з цими мікобактеріями та разом із Бріт займається більшістю організаційних питань у TB Companion.</p>", 6)
const _hoisted_110 = [
  _hoisted_104
]
const _hoisted_111 = { class: "team" }
const _hoisted_112 = {
  key: 0,
  class: "image"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Rick Shaikh", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profession" }, "Розробник програмного забезпечення", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Рік є технічним керівником і розробником програм для додатку TB Companion. Він втілює в життя всі наші ідеї та відповідає за програмування та підтримку TB Companion, щоб ваш компаньйон підтримував вас під час лікування туберкульозу.", -1))
const _hoisted_116 = [
  _hoisted_113,
  _hoisted_114,
  _hoisted_115
]
const _hoisted_117 = {
  key: 1,
  class: "image"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bannerimage",
  src: "/banner.png",
  alt: "banner"
}, null, -1))

export function render(_ctx, _cache) {
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Language = _resolveComponent("Language")
  const _component_el_image = _resolveComponent("el-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigation),
    _createVNode(_component_Language),
    (_ctx.lang=='en')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/1_happy.png" })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth > 600 ? 'text-left' : 'text-left-mobile')
            }, _hoisted_8, 2)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.windowWidth < 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/4_happy.png" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth >= 600 ? 'text-right' : 'text-left-mobile')
            }, _hoisted_14, 2),
            (_ctx.windowWidth >= 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/4_happy.png" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/2_happy.png" })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth > 600 ? 'text-left' : 'text-left-mobile')
            }, _hoisted_24, 2)
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_ctx.windowWidth < 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/3_happy.png" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth >= 600 ? 'text-right' : 'text-left-mobile')
            }, _hoisted_30, 2),
            (_ctx.windowWidth >= 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/3_happy.png" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/2_happy.png" })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth > 600 ? 'text-left' : 'text-left-mobile')
            }, _hoisted_37, 2)
          ]),
          _createElementVNode("div", _hoisted_38, [
            (_ctx.windowWidth < 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth >= 600 ? 'text-right' : 'text-left-mobile')
            }, _hoisted_43, 2),
            (_ctx.windowWidth >= 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.lang=='ro')
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/1_happy.png" })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth > 600 ? 'text-left' : 'text-left-mobile')
            }, _hoisted_51, 2)
          ]),
          _createElementVNode("div", _hoisted_52, [
            (_ctx.windowWidth < 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/4_happy.png" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth >= 600 ? 'text-right' : 'text-left-mobile')
            }, _hoisted_57, 2),
            (_ctx.windowWidth >= 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/4_happy.png" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/2_happy.png" })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth > 600 ? 'text-left' : 'text-left-mobile')
            }, _hoisted_67, 2)
          ]),
          _createElementVNode("div", _hoisted_68, [
            (_ctx.windowWidth < 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/3_happy.png" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth >= 600 ? 'text-right' : 'text-left-mobile')
            }, _hoisted_73, 2),
            (_ctx.windowWidth >= 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/3_happy.png" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/2_happy.png" })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth > 600 ? 'text-left' : 'text-left-mobile')
            }, _hoisted_80, 2)
          ]),
          _createElementVNode("div", _hoisted_81, [
            (_ctx.windowWidth < 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_82))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth >= 600 ? 'text-right' : 'text-left-mobile')
            }, _hoisted_86, 2),
            (_ctx.windowWidth >= 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.lang=='uk')
      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/1_happy.png" })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth > 600 ? 'text-left' : 'text-left-mobile')
            }, _hoisted_94, 2)
          ]),
          _createElementVNode("div", _hoisted_95, [
            (_ctx.windowWidth < 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/4_happy.png" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth >= 600 ? 'text-right' : 'text-left-mobile')
            }, _hoisted_100, 2),
            (_ctx.windowWidth >= 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/4_happy.png" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, [
              _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/2_happy.png" })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth > 600 ? 'text-left' : 'text-left-mobile')
            }, _hoisted_110, 2)
          ]),
          _createElementVNode("div", _hoisted_111, [
            (_ctx.windowWidth < 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/3_happy.png" })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.windowWidth >= 600 ? 'text-right' : 'text-left-mobile')
            }, _hoisted_116, 2),
            (_ctx.windowWidth >= 600)
              ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                  _createVNode(_component_el_image, { src: "https://tbcompanion.app/img/companions/3_happy.png" })
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_118
  ]))
}